import { useEffect, useState } from "react";
import { Typography, CircularProgress } from "@mui/material";
import { Container } from "@mui/system";
import { useParams } from "react-router-dom";
import globals from "../globals";

const MarketingEmailView = () => {
    const { sessionId } = useParams();
    const [html, setHtml] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        fetch(`${globals.apiUrl}/marketing/email/${sessionId}`, {
            headers: {
                'X-Frontend-Url': window.location.origin,
            },
        })
            .then((response) => {
                if (!response.ok) {
                    throw new Error('Имейлът не е намерен.');
                }
                return response.json();
            })
            .then((data) => {
                setHtml(data.html);
                setLoading(false);
            })
            .catch((err) => {
                setError(err.message);
                setLoading(false);
            });
    }, [sessionId]);

    if (loading) {
        return (
            <Container sx={{ display: 'flex', justifyContent: 'center', mt: 15 }}>
                <CircularProgress />
            </Container>
        );
    }

    if (error) {
        return (
            <Container sx={{ mt: 15, textAlign: 'center' }}>
                <Typography sx={{ fontSize: 20, color: globals.colors.darkRed }}>{error}</Typography>
            </Container>
        );
    }

    return (
        <iframe
            title="Marketing email"
            srcDoc={html}
            style={{
                width: '100%',
                height: '100vh',
                border: 'none',
                display: 'block',
            }}
        />
    );
};

export default MarketingEmailView;
